import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { intersection } from 'lodash'
import AuthMiddleware from './../modules/auth/middleware'
import { withRouter } from 'react-router-dom'

const mapStateToProps = ({ auth }) => ({
  permissions: auth.userRole.permissions,
  role: auth.userRole.role
})

const mapDispatchToProps = (dispatch) => (
 bindActionCreators({
   getRoles: () => AuthMiddleware.getRoles()
 }, dispatch)
)

const Authorization = (allowedPermission) => (WrappedComponent) => {
  class WithAuthorization extends Component {
    constructor (props) {
      super(props)
      this.isCoordinator = this.isCoordinator.bind(this)
      this.isDirector = this.isDirector.bind(this)
    }
    componentDidMount () {
      this.props.getRoles()
    }
    isDirector () {
      return this.props.role === 'director'
    }
    isCoordinator () {
      return this.props.role === 'coordinator'
    }
    render () {
      const { permissions } = this.props
      if (intersection(allowedPermission, permissions.map(permission => permission.name)).length > 0) {
        return <WrappedComponent isDirector={this.isDirector()} isCoordinator={this.isCoordinator()} {...this.props} />
      }
      return null
    }
  }
  return withRouter(connect(mapStateToProps, mapDispatchToProps)(WithAuthorization))
}

export default Authorization



// WEBPACK FOOTER //
// ./src/utils/Authorization.js